import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api/api.service';
import { GetListWoundCareProductModel } from 'app/core/models/wound-care-product/wound-care-product.model';
import { BaseApiResponse } from 'app/core/models/api/api.model';

@Injectable({
  providedIn: 'root',
})
export class WoundCareProductService {
  private apiURL = `${environment.apiLocations.patient}/wound-care-products`;

  private getListWoundCareProductURL = `${this.apiURL}/getListWoundCareProduct`;

  constructor(private apiService: ApiService) {}

  getWoundCareProducts(): Observable<
    BaseApiResponse<GetListWoundCareProductModel[]>
  > {
    return new Observable((observer) => {
      this.apiService.get(this.getListWoundCareProductURL).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }
}
